import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import PackageHeader from './PackagerHeader';
import Packages from './Packages';
import PackagerConfigWrapper from './config/PackagerConfigWrapper';
import {
  showPackagerConfigAtom,
  packagerIdForDocumentsModalAtom,
  packageEditDialogPackageIdAtom,
  completenessModalPackageIdAtom,
  packageEntriesDrilldownAtom,
} from '../../atoms/packager-atoms';
import { useAtom, useAtomValue } from 'jotai';
import PackagerDocuments from './PackagerDocuments';
import PackageEditStatus from './package/PackageEditStatus';
import CompletenessModal from './completeness/CompletenessModal';

const PackagerView: React.FC = () => {
  const [showPackagerConfig, setShowPackagerConfig] = useAtom(showPackagerConfigAtom);
  const [packagerIdForDocumentsModal, setPackagerIdForDocumentsModal] = useAtom(
    packagerIdForDocumentsModalAtom
  );
  const [packageEditDialogPackageId, setPackageEditDialogPackageId] = useAtom(
    packageEditDialogPackageIdAtom
  );
  const completenessModalPackageId = useAtomValue(completenessModalPackageIdAtom);
  const packageEntriesDrilldown = useAtomValue(packageEntriesDrilldownAtom);

  const { search } = useLocation();

  // Auto-open modal if step parameter is set and modal is not open
  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const stepParam = searchParams.get('step');

    if (stepParam && !showPackagerConfig) {
      setShowPackagerConfig(true);
    }
  }, [search]);

  return (
    <>
      <div>
        <PackageHeader />
        <Packages />
      </div>
      {showPackagerConfig ? <PackagerConfigWrapper /> : null}
      {packagerIdForDocumentsModal || packageEntriesDrilldown ? <PackagerDocuments /> : null}
      {completenessModalPackageId ? <CompletenessModal /> : null}
      {packageEditDialogPackageId && <PackageEditStatus />}
    </>
  );
};

export default PackagerView;
